import { useState, useEffect } from "react";
import { Input, Select } from "../../../../components/global";
import { SelectOptions } from "../../../../shared/interfaces/ISelectOptions";
import { StandardGrpApiService } from "../../../../shared/services/api/standard-grp-api.service";
import { IZones } from "../../../../shared/interfaces/IZones";
import { TextArea } from "../../../../components/global/textarea";

const ZoneUseOccupationName = () => (
    <Input
        name="zonas_use_occupation_nome"
        type="text"
        label="Nome do índice urbanístico"
    />
);

const ZoneUseOccupationValue = () => (
    <Input name="zonas_use_occupation_valor" type="text" label="Valor" />
);

const ZoneUseOccupationObservation = () => (
    <div className="row-span-3 flex flex-col">
        <TextArea name="zonas_use_occupation_observacao" label="Observação" />
    </div>
);

const ZoneUseOccupationOrder = () => (
    <Input
        name="zonas_use_occupation_ordem"
        type="number"
        label="Ordem de exibição"
    />
);

const ZoneFromApi = () => {
    const [options, setOptions] = useState<SelectOptions[]>([]);

    const convertOptions = (opts: IZones[]): SelectOptions[] =>
        opts.map((element) => ({
            label: element.zonas_tipo,
            value: element.id,
        }));

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const response = await StandardGrpApiService.get<IZones>({
                    path: "zoning",
                    params: {},
                });

                setOptions(convertOptions(response.data));
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error("Erro ao buscar tipo de emenda:", err);
            }
        };

        fetchOptions();
    }, []);

    return (
        <Select
            name="idzoneamento"
            label="Zoneamento"
            options={options}
            isClearable
        />
    );
};
export const FilterInputs = [
    ZoneUseOccupationName,
    ZoneUseOccupationValue,
    ZoneUseOccupationObservation,
    ZoneUseOccupationOrder,
    ZoneFromApi,
];

export const CreateInputs = [
    ZoneUseOccupationName,
    ZoneUseOccupationValue,
    ZoneUseOccupationObservation,
    ZoneUseOccupationOrder,
    ZoneFromApi,
];

export const UpdateInputs = [
    ZoneUseOccupationName,
    ZoneUseOccupationValue,
    ZoneUseOccupationObservation,
    ZoneUseOccupationOrder,
    ZoneFromApi,
];
